'use strict';

// ホバーで出すツールチップ（見た目は components/_hover_tooltip.scss）
// マークアップ: = link_to path, class: 'js-hover-tooltip', title: t('...'), 'aria-label': t('...') do
// - アイコンだけのボタンに操作名を添える。文言は title 属性に入れる（Bootstrap が表示用に引き取る）
// - ホバーのない端末では出さない（タップで出したままにならないように）
// - body 直下に出すので、スクロール領域や overflow: hidden の親で切り取られない
(function () {
  const SELECTOR = '.js-hover-tooltip';
  const hoverQuery = window.matchMedia('(hover: hover)');

  function initTooltips() {
    if (!window.bootstrap || !hoverQuery.matches) return;
    document.querySelectorAll(SELECTOR).forEach((el) => {
      window.bootstrap.Tooltip.getOrCreateInstance(el, {
        container: 'body', placement: 'bottom', trigger: 'hover', customClass: 'app-tooltip', offset: [0, 6]
      });
    });
  }

  function disposeTooltips() {
    if (!window.bootstrap) return;
    document.querySelectorAll(SELECTOR).forEach((el) => {
      const tooltip = window.bootstrap.Tooltip.getInstance(el);
      if (tooltip) tooltip.dispose();
    });
  }

  $(document).on('turbolinks:load', initTooltips);
  $(document).on('turbolinks:before-cache', disposeTooltips);
})();
